export default {
  sizeXSmall: 'xs',
  sizeSmall: 's',
  sizeMedium: 'm',
  sizeLarge: 'l',
  sizeXLarge: 'xl',
  size2XLarge: '2xl',
  sizeLabel(type) {
    switch(type) {
      case this.sizeXSmall:
        return Core.Definition.getDefinition('X-Small');
        break
      case this.sizeSmall:
        return Core.Definition.getDefinition('Small');
        break
      case this.sizeMedium:
        return Core.Definition.getDefinition('Medium');
        break
      case this.sizeLarge:
        return Core.Definition.getDefinition('Large');
        break
      case this.sizeXLarge:
        return Core.Definition.getDefinition('X-Large');
        break
      case this.size2XLarge:
        return Core.Definition.getDefinition('2X-Large');
        break
    }
  },
  sizeOptions(keys) {
    if (keys === undefined) {
      keys = [this.sizeXSmall, this.sizeSmall, this.sizeMedium, this.sizeLarge, this.sizeXLarge, this.size2XLarge]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.sizeLabel(key)
          }
      )
    }
    return options
  }
}
